import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid, Typography } from '@mui/material';
import { AnimatedOnScroll } from 'react-animated-css-onscroll';
// import HeaderText from '../../UI/Headers/HeaderText';

// Styles
const useStyles = makeStyles((theme) => ({
  image: {
    position: 'relative',
    height: 900,
    width: 100,
    zIndex: 101,
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(4),
    },
    [theme.breakpoints.between('0', '550')]: {
      height: 500,
    },
  },
  img: {
    height: 'auto',
    maxWidth: '100%',
  },
  header: {
    color: theme.palette.primary.main,
    textTransform: 'uppercase',
    textAlign: 'left',
  },
  subHeader: {
    color: theme.palette.interactive.main,
    textTransform: 'uppercase',
    textAlign: 'left',
  },
  container: {
    marginTop: 100,
  },
  imageTag: {
    width: '100%',
    height: '100%',
    layout: 'fill',
    objectFit: 'cover',
  },
}));

const Mangement = (props) => {
  const classes = useStyles();
  const { data } = props;

  const scrollRef = useRef();
  useEffect(() => {
    if (typeof window !== 'undefined' && window.location.search === '?id=5') {
      window.scrollTo(0, scrollRef.current.offsetTop - 60);
    }
  }, []);

  return (
    <Grid ref={scrollRef} container className={classes.container} alignItems="flex-start">
      <Grid container alignItems="flex-start">
        <Grid item xs={12} md={12} order={{ xs: 2, md: 1 }}>
          <Box position="relative" zIndex="100">
            <AnimatedOnScroll animationIn="fadeIn" animationInDuration={1000}>
              <Typography variant="h5" className={classes.subHeader}>{data.managementTitle1}</Typography>
              <Typography variant="h3" className={classes.header}>{data.managementSubTitle1}</Typography>
            </AnimatedOnScroll>
          </Box>
        </Grid>
      </Grid>
      <Grid item xs={12} md={12} className={classes.image}>
        <img className={classes.img} src={data ? data.managementPicture.url : '/'} width={900} height={1000} alt="Management" />
      </Grid>
    </Grid>
  );
};

export default Mangement;
